import { Link } from 'react-router-dom';

export function ContactPage() {
  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '48px 24px 80px' }}>
      <div
        className="mono"
        style={{
          fontSize: 11,
          textTransform: 'uppercase',
          letterSpacing: 0.08,
          color: 'var(--flame-2)',
          marginBottom: 8,
        }}
      >
        Contact
      </div>
      <h1 className="display" style={{ fontSize: 40, margin: '0 0 12px', letterSpacing: -0.02 }}>
        Get in touch
      </h1>
      <p style={{ fontSize: 15, color: 'var(--ink-2)', lineHeight: 1.55, margin: '0 0 36px' }}>
        Pick the inbox that matches what you need — we triage them daily and respond within one business day.
      </p>

      <div style={{ display: 'grid', gap: 14 }}>
        <ContactRow
          label="Sales"
          email="hello@emailforge.app"
          description="Pricing, security review, procurement. Happy to share a sandbox workspace and walk through the export-pack option."
        />
        <ContactRow
          label="Support"
          email="support@emailforge.app"
          description="Workspace issues, deliverability help, bug reports. Include your workspace slug so we can find it fast."
        />
        <ContactRow
          label="Privacy & data subject requests"
          email="privacy@emailforge.app"
          description={
            <>
              GDPR / CCPA / LGPD requests. See the{' '}
              <Link to="/privacy" style={{ color: 'var(--flame-2)' }}>Privacy Policy</Link> for the full scope of
              what we hold.
            </>
          }
        />
        <ContactRow
          label="Legal"
          email="legal@emailforge.app"
          description={
            <>
              DPA execution, SCCs, contract review. Reference{' '}
              <Link to="/dpa" style={{ color: 'var(--flame-2)' }}>/dpa</Link> when reaching out.
            </>
          }
        />
        <ContactRow
          label="Security"
          email="security@emailforge.app"
          description="Vulnerability reports — please use this address only. We acknowledge within 24 hours and never pursue legal action against good-faith research."
        />
      </div>

      <div
        style={{
          marginTop: 36,
          padding: 18,
          borderRadius: 'var(--r-3)',
          background: 'var(--paper-2)',
          border: '1px solid var(--line-soft)',
          fontSize: 13,
          color: 'var(--ink-2)',
          lineHeight: 1.6,
        }}
      >
        Need something faster? Workspace owners on Pro plans can open a ticket from{' '}
        <span className="mono">Settings → Billing → Open ticket</span> and we'll route it through the priority queue.
      </div>
    </div>
  );
}

function ContactRow({
  label,
  email,
  description,
}: {
  label: string;
  email: string;
  description: React.ReactNode;
}) {
  return (
    <div
      style={{
        padding: 18,
        border: '1px solid var(--line-soft)',
        borderRadius: 'var(--r-3)',
        background: 'var(--paper)',
        display: 'grid',
        gridTemplateColumns: '180px 1fr',
        gap: 18,
        alignItems: 'flex-start',
      }}
    >
      <div>
        <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 4 }}>{label}</div>
        <a
          href={`mailto:${email}`}
          className="mono"
          style={{ fontSize: 12, color: 'var(--flame-2)', textDecoration: 'none' }}
        >
          {email}
        </a>
      </div>
      <div style={{ fontSize: 13, color: 'var(--ink-2)', lineHeight: 1.55 }}>{description}</div>
    </div>
  );
}
